export const GET_USER_DATA = "USER:GET_USER_DATA"
export const GET_BALANCE = "USER:GET_BALANCE"
